import { Lock } from "lucide-react";

export default function AssistantEmptyState({ stepContext, questions, isPremium, onSend }) {
  return (
    <div className="space-y-3">
      <div className="rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-3 text-sm text-[var(--c-text)]">
        {stepContext ? (
          <>Hi! You&apos;re on <strong data-testid="assistant-context-label">{stepContext.label}</strong>. Ask me anything about it — or pick a question below.</>
        ) : (
          <>Hi! Ask me anything about forming your Texas LLC — I answer straight from the guide.</>
        )}
        {!isPremium && (
          <span className="mt-2 flex items-start gap-1.5 text-xs text-[var(--c-muted)]">
            <Lock className="mt-0.5 h-3 w-3 flex-shrink-0" /> Steps 3–9 details unlock with the $19 Full Guide.
          </span>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {questions.map((q, i) => (
          <button
            key={q}
            data-testid={`assistant-suggestion-${i}`}
            onClick={() => onSend(q)}
            className="rounded-full border-2 border-[var(--c-border)] bg-[var(--c-surface)] px-3 py-1.5 text-left text-xs font-semibold text-[var(--c-text)] shadow-[2px_2px_0px_var(--c-shadow)] transition-transform hover:-translate-y-0.5"
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
